import dataConstant from '../constants/dataConstants'

export async function getLeftMenuData() {
  return [
    // {
    //  title: 'Settings',
    //  key: 'settings',
    //  icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
    // },
    // {
    //   title: 'Documentation',
    //   key: 'documentation',
    //   url: 'https://docs.cleanuitemplate.com',
    //   target: '_blank',
    //   icon: 'icmn icmn-books',
    // },
    // {
    //   divider: true,
    // },
    {
      title: 'Dashboard',
      key: 'dashboardAlpha',
      url: '/dashboard/alpha',
      icon: 'icmn icmn-home',
      type: 'Admin',
    },
    {
      divider: true,
    },
  ]
}
export async function getTopMenuData() {
  // const userData = JSON.parse(localStorage.getItem('adminuser'))
  return [
    {
      title: 'Dashboard',
      key: 'dashboardAlpha',
      url: '/dashboard/alpha',
      icon: 'icmn icmn-home',
      type: dataConstant.RoleType.Client,
    },

    {
      title: 'Users',
      key: 'usermanagement',
      icon: 'icmn icmn-user',
      url: '/usermanagement',
      type: dataConstant.RoleType.Client,
    },
  ]
}
export async function getLoginUserType() {
  const response = JSON.parse(localStorage.getItem('adminuser'))
  return response
}
